import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import PRNService from 'src/app/services/PrnService';

@Component({
  selector: 'app-file-upload-dialog',
  templateUrl: './file-upload-dialog.component.html',
  styleUrls: ['./file-upload-dialog.component.scss']
})
export class FileUploadDialogComponent implements OnInit {

  @ViewChild(MatPaginator) paginator!: MatPaginator;

  displayedColumns: string[] = ['fileName', 'remarks', 'action'];
  dataSource = new MatTableDataSource<any>();

  fileToUpload: File[] = [];
  hasInvalidFile = false;
  btnDisable = true;
  remarks = '';
  userId: any;

  constructor(
    public dialogRef: MatDialogRef<FileUploadDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private prnService: PRNService,
    private snackBar: MatSnackBar
  ) {
    const currentUser = sessionStorage.getItem('currentUser');

    if (currentUser) {
      this.userId = JSON.parse(currentUser).id;
    }
  }

  ngOnInit(): void {
    this.showUploadedFiles();
  }

  onFileChange(files: FileList): void {

    this.hasInvalidFile = false;
    this.fileToUpload = [];

    const validExtensions = [
      'xlsx',
      'xls',
      'pdf',
      'docx',
      'jpg',
      'jpeg',
      'png'
    ];

    const maxSizeBytes = 1 * 1024 * 1024;

    Array.from(files).forEach((file) => {

      const ext = file.name.split('.').pop()?.toLowerCase() || '';

      if (!validExtensions.includes(ext)) {
        this.hasInvalidFile = true;
        return;
      }

      if (file.size > maxSizeBytes) {
        this.hasInvalidFile = true;
        return;
      }

      this.fileToUpload.push(file);
    });

    this.btnDisable = this.fileToUpload.length === 0;
  }

  uploadFiles(): void {

    this.dialogRef.close({
      files: this.fileToUpload,
      remarks: this.remarks
    });

  }

  showUploadedFiles(): void {

    if (!this.data?.module || !this.data?.id) {
      return;
    }

    const payload = {
      module: this.data.module,
      id: this.data.id
    };

    this.prnService.fetchUploadFile(payload).subscribe(
      (res: any) => {
        this.dataSource.data = res || [];
      }
    );
  }

  downloadFile(fileName: string): void {

    this.prnService
      .DOWNLOADFILE(this.data.module, fileName)
      .subscribe((res: any) => {

        const blob = new Blob([res]);
        const url = window.URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        a.click();

        this.snackBar.open(
          'File downloaded successfully',
          'Close',
          {
            duration: 3000,
            verticalPosition: 'top'
          }
        );
      });
  }

  deleteFile(fileName: string): void {

    this.prnService
      .DELETEFILE(this.data.module, fileName)
      .subscribe(() => {

        this.snackBar.open(
          'Deleted Successfully',
          'Close',
          {
            duration: 3000,
            verticalPosition: 'top'
          }
        );

        this.showUploadedFiles();
      });
  }

  close(): void {
    this.dialogRef.close();
  }
}